<template lang="html">
  <div>
    <div class="container" style="border-bottom:none;">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-col :span="12">
          <div class="grid-content">
            <h3>专题</h3>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content right">
            <router-link :to="{name: 'CreateTopic'}">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                size="small"
              >
                新建
              </el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-table
        border
        stripe
        v-loading="tableDataLoading"
        :data="tableData"
        style="width:100%">
        <el-table-column
          prop="id"
          label="编号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="episode_ids.length"
          label="节目数"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          width="160"
          :formatter="createdFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="hidden"
          label="状态"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.hidden === true ? 'info' : 'success'"
            >{{scope.row.hidden === true ? '隐藏' : '显示'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row, $event)"
            >
              编辑
            </el-button>
            <!-- <el-button
              size="mini"
              type="danger"
              @click="handleEdit(scope.$index, scope.row, $event)"
            >
              删除
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :total="totalCounts">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router'
  // import { Message } from 'element-ui'
  // import { MessageBox } from 'element-ui'
  import { Tag } from 'element-ui'
  import { Alert } from 'element-ui'
  import Vue from 'vue'
  Vue.use(Tag)
  Vue.use(Alert)

  export default {
    data() {
      return {
        tableDataLoading: true,
        tableData: [],
        totalCounts: 0,
      }
    },
    watch: {
    },
    methods: {
      getTopics (offset) {
        window.console.log("getTopic")
        let that = this
        let params = {
          offset: offset,
          slug: that.$route.params.slug
        }
        that.$api.topic.list(params).then(res => {
          window.console.log(res)
          that.tableData = res.data.results
          that.totalCounts = res.data.count
          that.tableDataLoading = false
        })
      },
      handleClick(row) {
        window.console.log(row);
      },
      handleCurrentChange(val) {
        window.console.log(`当前页: ${val}`)
        this.getTopics(val * 10 - 10)
      },
      handleEdit(index, row, event) {
        window.console.log("编辑")
        window.console.log(event.target)
        window.console.log(event.currentTarget)
        window.console.log(index)
        window.console.log(row)
        // let showSlug = row.show
        let topicId = row.id
        router.push({
          name: 'UpdateTopic',
          params: {
            id: topicId
          }
        })
      },
      createdFormatter (row, column, cellValue, index) {
        window.console.log("创建时间格式化：")
        window.console.log(row)
        window.console.log(column)
        window.console.log(cellValue)
        window.console.log(index)
        Date.prototype.format = function(fmt) { 
          var o = { 
            "M+" : this.getMonth()+1, //月份 
            "d+" : this.getDate(), //日 
            "h+" : this.getHours(), //小时 
            "m+" : this.getMinutes(), //分 
            "s+" : this.getSeconds(), //秒 
            "q+" : Math.floor((this.getMonth()+3)/3), //季度 
            "S"  : this.getMilliseconds() //毫秒 
          }; 
          if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
          }
          for(var k in o) {
            if(new RegExp("("+ k +")").test(fmt)){
              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            }
          }
          return fmt;
        }
        const t = new Date(cellValue).format("yyyy-MM-dd hh:mm:ss")
        return t
      }
    },
    mounted () {
      let offset = 0
      this.getTopics(offset)
    }
  }
</script>

<style lang="css">
  .alert-container {
    margin-bottom: 15px;
  }
  .pagination {
    width: 100%;
    margin-top: 15px;
    text-align: center;
  }
  h3 {
    margin: 0;
  }
  .block-container {
    margin-bottom: 15px;
  }
  .right {
    text-align: right;
  }
</style>
